import React, { useEffect } from 'react'
import { Images } from '@verzekeringapp-mono/shared/src/assets'
import { useLocation, useNavigate } from 'react-router-dom'
import LoginScreenWrapper from '~/components/screen_wrappers/login_screen_wrapper'
import TextInput from '~/components/TextInput'
import useAuthentication from '@verzekeringapp-mono/shared/src/hooks/use_authentication'
import Button from '~/components/Button'
import Modal from '~/components/Modal'
import { Controller, useForm } from 'react-hook-form'

const ForgotPasswordScreen: React.FC = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [error, setError] = React.useState('')
  const [isLoading, setIsLoading] = React.useState(false)
  const [successMessage, setSuccessMessage] = React.useState<string | null>(null)
  const {
    handleSubmit,
    formState: { isValid },
    control
  } = useForm({
    defaultValues: {
      email: state?.email || '',
      password: ''
    }
  })
  const { forgotPassword } = useAuthentication()

  const token =
    new URLSearchParams(location.search).get('token') ?? ''
  const email =
    new URLSearchParams(location.search).get('email') ?? ''

  useEffect(() => {
    if (token !== '' && email !== '') {
      navigate(`/forgot-password-verify?token=${token}&email=${email}`)
    }
  }, [token, email, navigate])

  const forgotPasswordFormSubmit = async (data: { email: string }) => {
    try {
      setIsLoading(true)
      const response = await forgotPassword(data.email)

      setSuccessMessage(response.message ?? 'Er is een e-mail verzonden met instructies om je wachtwoord te resetten.')
      setError('')
    } catch (error) {
      setSuccessMessage(null)
      setError((error as Error).message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <LoginScreenWrapper>
      <img
        src={Images.Logo}
        width={180}
        height={70}
      />

      <p className='title-medium mt-8'>Wachtwoord vergeten?</p>

      <p className='description mt-4'>
        Om je wachtwoord te resetten dien je je email in te vullen. Vervolgens
        ontvang je een e-mail met alle informatie om je wachtwoord te resetten.
      </p>

      <form
        onSubmit={handleSubmit(forgotPasswordFormSubmit)}
        className='w-full mt-8'
      >
        <Controller
          render={({ field, fieldState }) => (
            <TextInput
              {...field}
              label='E-mailadres'
              placeholder='Je e-mailadres'
              showValidationIcon={false}
              isValid={!fieldState.invalid}
              icon={'envelope'}
              autoComplete='email'
            />
          )}
          name='email'
          control={control}
          rules={{
            required: 'Dit veld is verplicht',
            pattern: {
              value: /^(?!\.)(?!.*\.\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+(?<!\.)@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
              message: 'Dit is geen geldig e-mailadres'
            }
          }}
        />

        {error && (
          <span
            className='labelError mt-4 whitespace-pre-line'
            dangerouslySetInnerHTML={{ __html: error }}
          />
        )}

        <Button
          className={'primary-btn w-full my-5'}
          type='submit'
          disabled={!isValid}
          isLoading={isLoading}
        >
          Verstuur
        </Button>

        <button
          className='secondary-btn w-full mt-4'
          onClick={goBack}
        >
          Terug
        </button>
      </form>

      {
        successMessage && (
          <Modal onClose={goBack}>
            <p>
              {successMessage}
            </p>
          </Modal>
        )
      }
    </LoginScreenWrapper>
  )

  function goBack () {
    navigate('/home')
  }
}

export default ForgotPasswordScreen
